module.exports = __webpack_public_path__ + "img/architecture.9258bb2b.svg";